import map_1f_atti from '@/assets/images/map_1f_atti2.webp';
import map_1f_raon from '@/assets/images/map_1f_raon.webp';
import map_2f_atti from '@/assets/images/map_2f_atti.webp';
import map_2f_raon from '@/assets/images/map_2f_raon.webp';
import map_b1f from '@/assets/images/map_b1f.webp';
import map_b2f_park from '@/assets/images/map_b2f_park.webp';
import map_b3f_park from '@/assets/images/map_b3f_park.webp';
const getZoneMap = (zone: string) => {
  switch (zone) {
    case '1F_atti':
      return map_1f_atti;
    case '1F_raon':
      return map_1f_raon;
    case '2F_atti':
      return map_2f_atti;
    case '2F_raon':
      return map_2f_raon;
    case 'B1F':
      return map_b1f;
    case 'B2F':
      return map_b2f_park;
    case 'B3F':
      return map_b3f_park;
    default:
      return null;
  }
};

export default getZoneMap;
